import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {removeWord} from '../helpers/localApi';

export function useDeleteWord(selectedKey) {
  const [state, dispatch] = useContext(Context);
  const {language} = state;

  const deleteWord = async (selectedKey) => {
    if (selectedKey !== undefined) {
      try {
        await removeWord({language, id: selectedKey});
        dispatch({type: 'REMOVE_WORD', payload: selectedKey});
      } catch (error) {
        console.error('Error deleting word: ', error);
      }
    }
  };

  return {deleteWord};
};
